import { gql } from '@apollo/client';

import { contentfulSysIdFragment } from '../../../utils/contentful/contentfulQuery';

export const salesforceConnectorFragment = gql`
  fragment SalesforceConnectorAll on SalesforceConnector {
    category
    year
    confirmationEmail {
      ...ContentfulSysId
    }
    ...ContentfulSysId
  }
  ${contentfulSysIdFragment}
`;

export const cventConnectorFragment = gql`
  fragment CventConnectorAll on CventConnector {
    eventId
    admissionItemId
    invitationListId
    allowlistErrorText {
      json
    }
    ...ContentfulSysId
  }
  ${contentfulSysIdFragment}
`;

export const zkipsterConnectorFragment = gql`
  fragment ZkipsterConnectorAll on ZkipsterConnector {
    eventId
    guestListId
    allowlistErrorText {
      json
    }
    isOpenRegistration
    confirmationEmail {
      ...ContentfulSysId
    }
    ...ContentfulSysId
  }
  ${contentfulSysIdFragment}
`;

export const splashConnectorFragment = gql`
  fragment SplashConnectorAll on SplashConnector {
    eventId
    confirmationEmail {
      ...ContentfulSysId
    }
    ...ContentfulSysId
  }
  ${contentfulSysIdFragment}
`;
